import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000/api';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle common errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const priorityMasterService = {
  // Get all priority masters with pagination and filters
  getAllPriorityMasters: async (params = {}) => {
    try {
      const response = await api.get('/priority-masters', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching priority masters:', error);
      throw error;
    }
  },

  // Get priority master by ID
  getPriorityMasterById: async (id) => {
    try {
      const response = await api.get(`/priority-masters/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching priority master:', error);
      throw error;
    }
  },

  // Create new priority master
  createPriorityMaster: async (data) => {
    try {
      const response = await api.post('/priority-masters', data);
      return response.data;
    } catch (error) {
      console.error('Error creating priority master:', error);
      throw error;
    }
  },

  // Update priority master
  updatePriorityMaster: async (id, data) => {
    try {
      const response = await api.put(`/priority-masters/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating priority master:', error);
      throw error;
    }
  },

  // Delete priority master (soft delete)
  deletePriorityMaster: async (id) => {
    try {
      const response = await api.delete(`/priority-masters/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting priority master:', error);
      throw error;
    }
  },

  // Get priority master statistics
  getPriorityMasterStats: async () => {
    try {
      const response = await api.get('/priority-masters/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching priority master stats:', error);
      throw error;
    }
  }
};

export default priorityMasterService;

